import withStyles from "@material-ui/core/es/styles/withStyles";
import { withRouter } from "react-router";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import NotesIcon from "@material-ui/icons/Notes";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import PhoneEnabledIcon from "@material-ui/icons/PhoneEnabled";

import React from "react";
import Notes from "./notes.component";

import BookCalls from "../user_requests/components/user_request.bookcalls-form.component";

const styles = (theme) => ({
  speedDial: {
    position: "fixed",
    bottom: theme.spacing.unit * 3,
    right: theme.spacing.unit * 3,
  },
});

class SpeedDialTooltipOpen extends React.Component {
  state = {
    open: false,
    hidden: false,
    notes: false,
  };

  toggleNotes = () => {
    const notes = this.state.notes;
    this.setState({
      notes: !notes,
    });
  };

  closeNotes = () => {
    this.setState({
      notes: false,
    });
  };

  toggleBookCall = () => {
    const element = document.getElementById("div-bookcalls");
    element.classList.toggle("d-none");
  };

  toggleNewEntityGroup = () => {
    const element = document.getElementById("new_group_form");
    element.classList.toggle("d-none");
  };

  newRequest = () => {
    this.props.history.push("/user_requests/new");
  };

  handleClick = () => {
    this.setState((state) => ({
      open: !state.open,
      notes: false,
      bookcalls: false,
    }));
  };

  render() {
    const { classes } = this.props;
    const { hidden, open } = this.state;

    const actions = this.props.showCreateNewEntitiesGroup
      ? [
          {
            icon: <GroupAddIcon />,
            name: "Criar grupo novo",
            action: this.toggleNewEntityGroup,
          },
        ]
      : this.props.showOnlyNotes
      ? [
          {
            icon: <NotesIcon />,
            name: "Notas",
            action: this.toggleNotes,
          },
        ]
      : this.props.hideBookcalls
      ? [
          {
            icon: <NotesIcon />,
            name: "Notas",
            action: this.toggleNotes,
          },
          {
            icon: <LibraryAddIcon />,
            name: "Novo Pedido",
            action: this.newRequest,
          },
        ]
      : [
          {
            icon: <NotesIcon />,
            name: "Notas",
            action: this.toggleNotes,
          },
          {
            icon: <LibraryAddIcon />,
            name: "Novo Pedido",
            action: this.newRequest,
          },
          {
            icon: <PhoneEnabledIcon />,
            name: "Agendar Contacto",
            action: this.toggleBookCall,
          },
        ];

    return (
      <>
        {open && (
          <div id="div-bookcalls" class="d-none">
            <BookCalls
              getDateFromLastBookcall={this.props.getDateFromLastBookcall}
            ></BookCalls>
          </div>
        )}
        {this.state.notes && (
          <Notes
            open={this.state.notes}
            handleClose={this.closeNotes}
            {...this.props}
          />
        )}
        <SpeedDial
          ariaLabel="SpeedDial"
          className={classes.speedDial}
          hidden={hidden}
          icon={<SpeedDialIcon />}
          //onBlur={this.handleClose}
          FabProps={{
            onClick: this.handleClick,
          }}
          open={open}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={action.action}
            />
          ))}
        </SpeedDial>
      </>
    );
  }
}

export default withRouter(withStyles(styles)(SpeedDialTooltipOpen));
